import React, { Component } from "react"
import { Link, withRouter } from "react-router-dom"
import { PropTypes } from "prop-types"
import { connect } from 'react-redux'
import pubsub from "pubsub-js"
import { getUserRole } from "../../redux/actions/action_user"
import SidebarRun from "./Sidebar.run"

class Sidebar extends Component {
  static propTypes = {
    history: PropTypes.object,
    location: PropTypes.object
  }
  constructor(props, context) {
    super(props, context);
    this.state = {
      roleChecked:false
    }
    this.applyPermission =  this.applyPermission.bind(this)
  }

  componentDidMount() {
    // pass navigator to access router api
    SidebarRun(this.navigator.bind(this))
    const { roleChecked } = this.props.user
    if(roleChecked === false)
    {
       getUserRole()
    }
  }

  componentWillUnmount() {
    // React removed me from the DOM, I have to unsubscribe from the pubsub using my token
    pubsub.unsubscribe(this.pubsub_token)
  }

  navigator(route) {
    const { history } = this.props
    history.push(route)
  }

  routeActive(paths) {
    paths = Array.isArray(paths) ? paths : [paths];
    if (paths.indexOf(this.props.location.pathname.replace("/", "")) > -1) return true;
    return false
  }

  applyPermission()
  {
    const { user , oidc } = this.props
    const { roleChecked  } = user

    if(oidc.user !== null) {
      if((roleChecked === false) && (this.state.roleChecked === false))
      {
        this.props.dispatch(getUserRole()) 
        this.setState({ 
          roleChecked:true
        }) 
      } 
    }
  }

  render() {

    const { roleName, roleChecked } = this.props.user;
 
    if (roleChecked === false) {
      this.applyPermission()
    }  

    const isAdmin = roleName === 'Administrator'

    return (
     <aside className="aside" >
        <div className="aside-inner">
        <nav data-sidebar-anyclick-close className="sidebar">
          <ul className="nav">
            <li className={this.routeActive("dashboard") ? "active" : ""}>
              <Link to="dashboard" title="Dashboard">
                <em className="fa fa-tachometer" />
                <span>Dashboard</span>
              </Link>
            </li>
            { (isAdmin === true) && (<li>
              <a href="#" title="Event Management">
                <em className="fa fa-calendar" />
                <span>Season</span>
              </a>
              <ul id="tournamentarea" className="nav sidebar-subnav">  
                <li className={this.routeActive(["seasonsettings"]) ? "active" : ""}>
                  <Link to="seasonsettings" title="Tournament setup settings">                
                    <span>Season Settings</span>
                  </Link>
                </li>
                <li className={this.routeActive(["reports"]) ? "active" : ""}>
                  <Link to="reports" title="Reports">                
                    <span>Reports</span>
                  </Link>
                </li>              
              </ul>
            </li>) }
          <li>
            <a href="#" title="Event Management">
              <em className="fa fa-calendar-plus-o" />
              <span>Event</span>
            </a>
            <ul id="tournamentarea" className="nav sidebar-subnav">
              <li className={this.routeActive(["viewevents"]) ? "active" : ""}>
                <Link to="viewevents"  title="View Event" disabled>
                  <span>View Events</span>
                </Link>
              </li>
              <li className={this.routeActive(["event"]) ? "active" : ""} >
                <Link to={{ 
                    pathname:'/event',
                    state: {
                      fromSidebar: true,
                    }
                   }}  
                   title="Setup Event">
                  <span>Event Setup</span>
                </Link>
              </li>
              <li className={this.routeActive(["postevent"]) ? "active" : ""} >
                <Link to={{ 
                    pathname:'/postevent',
                    state: {
                      fromSidebar: true,
                    }
                   }}  
                   title="Post Event Management">
                  <span>Post Event Management</span>
                </Link>
              </li>
              { (isAdmin === true) && (<li className={this.routeActive(["manageadvancers"]) ? "active" : ""} >
              <Link to={{ 
                  pathname:'/manageadvancers',
                  state: {
                    fromSidebar: true,
                  }
                  }}  
                  title="Manage Advancers">
                <span>Manage Advancers</span>
              </Link>
            </li>)}
            { (isAdmin === true) && (
            <li className={this.routeActive(["orphanedevents"]) ? "active" : ""}>
              <Link to="orphanedevents" title="Orphaned Events">                
                  <span>Orphaned Events</span>
              </Link>
            </li>)}
            { (isAdmin === true) && (   
            <li className={this.routeActive(["managedeposits"]) ? "active" : ""} >
              <Link to={{ 
                  pathname:'/managedeposits',
                  state: {
                    fromSidebar: true,
                  }
                  }}  
                  title="Manage Funds">
                <span>Manage Funds</span>
              </Link>
            </li>)}
            </ul>
          </li> 
          {
          (isAdmin === true) && (
          <li>
            <hr style={{ height:'1px' }}/>
          </li>
          )}
          {
          (isAdmin === true) && (
            <li className={this.routeActive(["usermanagement"]) ? "active" : ""}>
            <Link to="usermanagement" title="User Management">
              <em className="fa fa-users" />
              <span>User Management</span>
            </Link>
          </li>)
          }  
          </ul>
          </nav>
        </div>       
      </aside>
    )
  }
}

Sidebar.propTypes = {
  dispatch: PropTypes.func,
  oidc:PropTypes.object,
  user:PropTypes.object,
}

const mapStateToProps = ({  oidc, user }) => {
	return {
    oidc: { ...oidc },
    user: { ...user },
	}
}
export default withRouter(connect(mapStateToProps,null)(Sidebar))


// WEBPACK FOOTER //
// ./src/components/layout/Sidebar.js